export const mustBeMoreThan =
  (min: number, message?: string, allowEmpty: boolean = true) =>
  (value: string) => {
    if (allowEmpty && !value) return undefined;
    return min <= value.length
      ? undefined
      : message || `Veuillez saisir au moins ${min} caractères.`;
  };
